import { render, staticRenderFns } from "./ModalTermoAceite.vue?vue&type=template&id=4f9e7d88&scoped=true&"
import script from "./ModalTermoAceite.vue?vue&type=script&lang=js&"
export * from "./ModalTermoAceite.vue?vue&type=script&lang=js&"
import style0 from "./ModalTermoAceite.vue?vue&type=style&index=0&id=4f9e7d88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9e7d88",
  null
  
)

export default component.exports